/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Button,
  Table,
  Modal,
  Message,
  Form as FormUi,
  Icon,
  Dropdown,
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import { MyInput, MyNormalInput } from "../dynamicComponent/myInputs";
import ReadAxios from "../axiosComponent/read";
import { isEmpty } from "lodash";
import CreateAxios from "../axiosComponent/create";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { translate } from "react-i18next";
import VehicleType from "./vehicleTypeName";
import moment from "moment";

const ModalBidHistory = ({ values, isSubmitting, handleSubmit, setFieldValue, t, bids }) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [Vendors, setVendors] = useState([]);
  useEffect(() => {
    // getAllVendors();
    console.log('check bids', bids);
  }, []);
  let handleOpen = () => setmodalOpen(true);
  let handleClose = () => {
    setmodalOpen(false);
  };
  

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        size="tiny"
        trigger={
          <Button icon
            type="button"
            onClick={handleOpen}
            size="mini"
            // className="w3-blue w3-round w3-hover-blue"
          >
            <Icon name='info circle' />
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">{t("title") || "Allot Shipment"}</Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description style={{ height: "10em" }}>
            {bids.length > 0 ? (
                <Table className="w3-small" size="small" striped>
                    <Table.Header>
                    <Table.Row>
                    <Table.HeaderCell className="p-bold-500">
                        {t("table.sr_no") || "Sr No"}
                    </Table.HeaderCell>
                    <Table.HeaderCell className="p-bold-500">
                        {t("table.date_time") || "Sr No"}
                    </Table.HeaderCell>
                    <Table.HeaderCell className="p-bold-500">
                        {t("table.amount") || "Sr No"}
                    </Table.HeaderCell>
                    <Table.HeaderCell className="p-bold-500">
                        {t("table.available_vehicle") || "Sr No"}
                    </Table.HeaderCell>
                    </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        <>
                        {bids.map((reply, index) => (
                        <Table.Row key={index}>
                            <Table.Cell>
                            {index + 1}
                            </Table.Cell>
                            <Table.Cell>
                            {moment(reply.created_on).format("DD-MM-YYYY")}
                            </Table.Cell>
                            <Table.Cell>
                            {reply.bid_amount}
                            </Table.Cell>
                            <Table.Cell>
                            <VehicleType
                            VehicleId={reply.vehicle_type_id} />
                            </Table.Cell>
                        </Table.Row>
                        ))}
                        </>
                    </Table.Body>
                </Table>
            ) : (
                <Message floating>{t("message") || "No bid history available"}</Message>
            )} 
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {/* {isSubmitting ? "Loading..." : ""} */}
          <Button
            type="submit"
            onClick={handleClose}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("btn_ok") || "OK"}
          </Button>
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("bidhistory")(ModalBidHistory)
);
